import { ScanSearch } from 'lucide-react';

export default function Brand({ compact = false }) {
  return (
    <div className={`brand ${compact ? 'brand-compact' : ''}`}>
      <span className="brand-symbol"><ScanSearch size={compact ? 20 : 24} /></span>
      <span className="brand-copy"><strong>Menu Finder</strong><small>VISION</small></span>
    </div>
  );
}
